const PRESETS = {
	footer: {
		icon: 'energy',
		message: ['End of this page, onto the next?', 'Discover more. Click onward!', "Don't stop now! Click for more!"],
	},
}

export function getRemarkPreset(name) {
	return Object.hasOwn(PRESETS, name) ? PRESETS[name] : null
}
